var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 67,
    viewBox: "0 0 140 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0288 49.4826C38.0288 53.7261 36.1141 57.7959 32.706 60.7965C29.2979 63.7972 24.6755 65.4829 19.8557 65.4829",
    stroke: "#B53214",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.68262 49.4826C1.68262 53.7261 3.59728 57.7959 7.00539 60.7965C10.4135 63.7972 15.0359 65.4829 19.8557 65.4829",
    stroke: "#B53214",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.68262 17.4819C1.68262 21.7254 3.59728 25.7952 7.00539 28.7958C10.4135 31.7965 15.0359 33.4822 19.8557 33.4822",
    stroke: "#B53214",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0288 17.4819C38.0288 13.2383 36.1141 9.16858 32.706 6.16793C29.2979 3.16728 24.6755 1.48154 19.8557 1.48154",
    stroke: "#B53214",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0288 49.4826C38.0288 45.239 36.1141 41.1693 32.706 38.1686C29.2979 35.168 24.6755 33.4822 19.8557 33.4822",
    stroke: "#B53214",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.68262 17.4819C1.68262 13.2383 3.59728 9.16855 7.00539 6.1679C10.4135 3.16725 15.0359 1.48151 19.8557 1.48151",
    stroke: "#B53214",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.317 49.4826C138.317 53.7261 136.402 57.7959 132.994 60.7965C129.586 63.7972 124.964 65.4829 120.144 65.4829",
    stroke: "#B53214",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.971 49.4826C101.971 53.7261 103.886 57.7959 107.294 60.7965C110.702 63.7972 115.324 65.4829 120.144 65.4829",
    stroke: "#B53214",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.317 17.4819C138.317 13.2383 136.402 9.16858 132.994 6.16793C129.586 3.16728 124.964 1.48154 120.144 1.48154",
    stroke: "#B53214",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7385 17.4819C88.7385 13.2383 86.8239 9.16858 83.4157 6.16793C80.0076 3.16728 75.3852 1.48154 70.5654 1.48154",
    stroke: "#B53214",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3923 17.4819C52.3923 13.2383 54.307 9.16858 57.7151 6.16793C61.1232 3.16728 65.7456 1.48154 70.5654 1.48154",
    stroke: "#B53214",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7383 17.4819V67",
    stroke: "#B53214",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3923 17.4819V67",
    stroke: "#B53214",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.317 17.4819V49.4826",
    stroke: "#B53214",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8162 33.4822H88.5969",
    stroke: "#B53214",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6327 1.48154H70.4981C60.4986 1.48154 52.3923 8.61861 52.3923 17.4226V49.5419C52.3923 58.3459 60.4986 65.483 70.4981 65.483H70.6327C80.6323 65.483 88.7385 58.3459 88.7385 49.5419V17.4226C88.7385 8.61861 80.6323 1.48154 70.6327 1.48154Z",
    stroke: "#F2F2F2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8557 65.4829C29.8924 65.4829 38.0288 58.3193 38.0288 49.4826C38.0288 40.6458 29.8924 33.4822 19.8557 33.4822C9.81898 33.4822 1.68262 40.6458 1.68262 49.4826C1.68262 58.3193 9.81898 65.4829 19.8557 65.4829Z",
    stroke: "#F2F2F2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8557 33.4822C29.8924 33.4822 38.0288 26.3186 38.0288 17.4819C38.0288 8.64511 29.8924 1.48151 19.8557 1.48151C9.81898 1.48151 1.68262 8.64511 1.68262 17.4819C1.68262 26.3186 9.81898 33.4822 19.8557 33.4822Z",
    stroke: "#F2F2F2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.144 65.4829C130.181 65.4829 138.317 58.3193 138.317 49.4826C138.317 40.6458 130.181 33.4822 120.144 33.4822C110.108 33.4822 101.971 40.6458 101.971 49.4826C101.971 58.3193 110.108 65.4829 120.144 65.4829Z",
    stroke: "#F2F2F2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.144 33.4822C130.181 33.4822 138.317 26.3186 138.317 17.4819C138.317 8.64514 130.181 1.48154 120.144 1.48154C110.108 1.48154 101.971 8.64514 101.971 17.4819C101.971 26.3186 110.108 33.4822 120.144 33.4822Z",
    stroke: "#F2F2F2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5654 65.4829C80.6021 65.4829 88.7385 58.3193 88.7385 49.4826C88.7385 40.6458 80.6021 33.4822 70.5654 33.4822C60.5287 33.4822 52.3923 40.6458 52.3923 49.4826C52.3923 58.3193 60.5287 65.4829 70.5654 65.4829Z",
    stroke: "#F2F2F2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5654 33.4822C80.6021 33.4822 88.7385 26.3186 88.7385 17.4819C88.7385 8.64514 80.6021 1.48154 70.5654 1.48154C60.5287 1.48154 52.3923 8.64514 52.3923 17.4819C52.3923 26.3186 60.5287 33.4822 70.5654 33.4822Z",
    stroke: "#F2F2F2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.212 1.48154H120.077C110.077 1.48154 101.971 8.61861 101.971 17.4226V49.5419C101.971 58.3459 110.077 65.483 120.077 65.483H120.212C130.211 65.483 138.317 58.3459 138.317 49.5419V17.4226C138.317 8.61861 130.211 1.48154 120.212 1.48154Z",
    stroke: "#F2F2F2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.923 1.48151H19.7884C9.78885 1.48151 1.68262 8.61858 1.68262 17.4226V49.5418C1.68262 58.3459 9.78885 65.4829 19.7884 65.4829H19.923C29.9225 65.4829 38.0288 58.3459 38.0288 49.5418V17.4226C38.0288 8.61858 29.9225 1.48151 19.923 1.48151Z",
    stroke: "#F2F2F2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.68262 33.4822H138.317",
    stroke: "#F2F2F2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3923 49.6426V66.9644",
    stroke: "#F2F2F2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7383 49.4826V66.9644",
    stroke: "#F2F2F2",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 67,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.df3207343f2eaa518f069e0bdda8a46e.svg";
export { ForwardRef as ReactComponent };